import React from 'react';
import { LinkContainer} from 'react-router-bootstrap';
import Navigation from '../NavigationBar/index';
import { Image } from 'semantic-ui-react';
import logo from '../../images/favicon1.jpeg';

import './style.css';

class Header extends React.Component {
  render() {
    return <div className="Header">
      <LinkContainer to='/'>
        <Image src={logo} size='small' className='Logo'/>
      </LinkContainer>
      < Navigation />
    </div>;
  }
}

export default Header;
